'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002eui$002e$002dButton$0024$0024anon$00241 from "./io.intela.sites.digitalinternship.ui.-Button$$anon$1.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002eui$002e$002dButton$0024$0024anon$00242 from "./io.intela.sites.digitalinternship.ui.-Button$$anon$2.js";
var $p;
function $s_Lio_intela_sites_digitalinternship_ui_Button$__Primary__Lio_intela_sites_digitalinternship_ui_Button() {
  $m_Lio_intela_sites_digitalinternship_ui_Button$();
  return $t_Lio_intela_sites_digitalinternship_ui_Button$__Primary;
}
export { $s_Lio_intela_sites_digitalinternship_ui_Button$__Primary__Lio_intela_sites_digitalinternship_ui_Button as $s_Lio_intela_sites_digitalinternship_ui_Button$__Primary__Lio_intela_sites_digitalinternship_ui_Button };
function $s_Lio_intela_sites_digitalinternship_ui_Button$__Outline__Lio_intela_sites_digitalinternship_ui_Button() {
  $m_Lio_intela_sites_digitalinternship_ui_Button$();
  return $t_Lio_intela_sites_digitalinternship_ui_Button$__Outline;
}
export { $s_Lio_intela_sites_digitalinternship_ui_Button$__Outline__Lio_intela_sites_digitalinternship_ui_Button as $s_Lio_intela_sites_digitalinternship_ui_Button$__Outline__Lio_intela_sites_digitalinternship_ui_Button };
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_ui_Button$() {
  $n_Lio_intela_sites_digitalinternship_ui_Button$ = this;
  $t_Lio_intela_sites_digitalinternship_ui_Button$__Primary = new $j_io$002eintela$002esites$002edigitalinternship$002eui$002e$002dButton$0024$0024anon$00241.$c_Lio_intela_sites_digitalinternship_ui_Button$$anon$1();
  $t_Lio_intela_sites_digitalinternship_ui_Button$__Outline = new $j_io$002eintela$002esites$002edigitalinternship$002eui$002e$002dButton$0024$0024anon$00242.$c_Lio_intela_sites_digitalinternship_ui_Button$$anon$2();
  $s_Lio_intela_sites_digitalinternship_ui_Button$__Primary__Lio_intela_sites_digitalinternship_ui_Button();
  $s_Lio_intela_sites_digitalinternship_ui_Button$__Outline__Lio_intela_sites_digitalinternship_ui_Button();
}
export { $c_Lio_intela_sites_digitalinternship_ui_Button$ as $c_Lio_intela_sites_digitalinternship_ui_Button$ };
$p = $c_Lio_intela_sites_digitalinternship_ui_Button$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_ui_Button$;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_ui_Button$() {
}
export { $h_Lio_intela_sites_digitalinternship_ui_Button$ as $h_Lio_intela_sites_digitalinternship_ui_Button$ };
$h_Lio_intela_sites_digitalinternship_ui_Button$.prototype = $p;
var $d_Lio_intela_sites_digitalinternship_ui_Button$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_ui_Button$, "io.intela.sites.digitalinternship.ui.Button$", ({
  fy: 1,
  y: 1,
  ar: 1
}));
export { $d_Lio_intela_sites_digitalinternship_ui_Button$ as $d_Lio_intela_sites_digitalinternship_ui_Button$ };
var $n_Lio_intela_sites_digitalinternship_ui_Button$;
function $m_Lio_intela_sites_digitalinternship_ui_Button$() {
  if ((!$n_Lio_intela_sites_digitalinternship_ui_Button$)) {
    $n_Lio_intela_sites_digitalinternship_ui_Button$ = new $c_Lio_intela_sites_digitalinternship_ui_Button$();
  }
  return $n_Lio_intela_sites_digitalinternship_ui_Button$;
}
export { $m_Lio_intela_sites_digitalinternship_ui_Button$ as $m_Lio_intela_sites_digitalinternship_ui_Button$ };
var $t_Lio_intela_sites_digitalinternship_ui_Button$__Primary = null;
function $u_Lio_intela_sites_digitalinternship_ui_Button$__Primary(x) {
  $t_Lio_intela_sites_digitalinternship_ui_Button$__Primary = x;
}
export { $t_Lio_intela_sites_digitalinternship_ui_Button$__Primary as $t_Lio_intela_sites_digitalinternship_ui_Button$__Primary, $u_Lio_intela_sites_digitalinternship_ui_Button$__Primary as $u_Lio_intela_sites_digitalinternship_ui_Button$__Primary };
var $t_Lio_intela_sites_digitalinternship_ui_Button$__Outline = null;
function $u_Lio_intela_sites_digitalinternship_ui_Button$__Outline(x) {
  $t_Lio_intela_sites_digitalinternship_ui_Button$__Outline = x;
}
export { $t_Lio_intela_sites_digitalinternship_ui_Button$__Outline as $t_Lio_intela_sites_digitalinternship_ui_Button$__Outline, $u_Lio_intela_sites_digitalinternship_ui_Button$__Outline as $u_Lio_intela_sites_digitalinternship_ui_Button$__Outline };
//# sourceMappingURL=io.intela.sites.digitalinternship.ui.-Button$.js.map
